import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { LogOut, Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

export const LogoutButton = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleSignOut = async () => {
    if (isLoading) return; // Verhindere mehrfache Klicks
    
    setIsLoading(true);
    try {
      await signOut();
      toast.success('Erfolgreich abgemeldet');
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
      toast.error('Fehler beim Abmelden. Bitte versuche es erneut.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="ghost"
      className="text-gray-600 hover:text-red-600"
      onClick={handleSignOut}
      disabled={isLoading}
      title="Abmelden"
    >
      {isLoading ? (
        <Loader2 className="w-4 h-4 sm:mr-2 animate-spin" />
      ) : (
        <LogOut className="w-4 h-4 sm:mr-2" />
      )}
      <span className="hidden sm:inline">
        {isLoading ? 'Abmelden...' : 'Abmelden'}
      </span>
    </Button>
  );
}; 